import type { FC } from "react";

import * as CSS from "./feed-var-review.styles";

const FeedVarReview: FC = () => {
	return (
		<CSS.VarReview>
			<span>VAR review in progress</span>
		</CSS.VarReview>
	);
};

export default FeedVarReview;
